import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import GroupIcon from '@material-ui/icons/Group';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { Page, Header } from 'components';
import { DownloadFile } from 'actions/sessionActions.js';
import VoiceDataTable from './components/VoiceDataTable';
import VoiceEditFailureDialog from './components/VoiceEditFailureDialog/VoiceEditFailureDialog';

import { GetFailuresVoice, ToggleVoiceEditFailureDialog, ExportFailuresVoice } from '../../actions/VoiceActions';

const useStyles = makeStyles((theme) => ({
	root: {
		// padding: theme.spacing(3),
	},
	container: {
		// marginTop: theme.spacing(3),
	},
}));

const Voice = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const failures = useSelector((state) => state.voiceReducer.failures);
	const voiceEditFailureDialogVisibility = useSelector((state) => state.voiceReducer.voiceEditFailureDialogVisibility);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _getData = useCallback(() => {
		dispatch(GetFailuresVoice(userId, role));
	}, []);

	useEffect(() => {
		if (failures !== undefined) {
			_getData();
		}
	}, []);

	const _voiceEditFailureDialogClose = () => {
		dispatch(ToggleVoiceEditFailureDialog(false));
	};

	const _onExportFailuresClick = () => {
		dispatch(ExportFailuresVoice(userId, role));
	};

	return (
		<Page className={classes.root} title="Voice Failures">
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<Button
						className={classes.agreeButton}
						color="primary"
						onClick={_onExportFailuresClick}
						variant="contained"
						size="small"
					>
						Export Failures
					</Button>
				</Grid>
				<Grid item lg={12} xs={12}>
					<VoiceDataTable className={classes.results} data={failures} />
				</Grid>
			</Grid>
			{voiceEditFailureDialogVisibility && (
				<VoiceEditFailureDialog
					onClose={_voiceEditFailureDialogClose}
					open={voiceEditFailureDialogVisibility}
				/>
			)}
		</Page>
	);
};

export default Voice;
